import styled from 'styled-components';

import { Button } from '../../../app/components/Button/Button';
import { ReactComponent as GoogleLogo } from '../../../../assets/google.svg';

export const StyledButton = styled(Button)`
  background-color: #fff;
`;

export const StyledGoogleLogo = styled(GoogleLogo)`
  margin-right: 15px;
`;
